import React, { useState, useEffect,useRef } from 'react'
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import DataService from "./services/DataService";
import ReCaptchaV2  from 'react-google-recaptcha'; 
import ReCAPTCHA  from 'react-google-recaptcha';


function App() {
  const initFormValue = { memberId:"",
                          memberName:"",
                          cardNumber:"",
                          promotionId:"",
                          mobile:"+",
                          email:"",
                          token:"",
                          marketFlag:false,
                          timezone:Intl.DateTimeFormat().resolvedOptions().timeZone
                        };
  const [formValue,setFormValue] = useState(initFormValue);
  const [submitted, setSubmitted] = useState(false)
  const [errors, setErrors] = useState({})
  const [errorsName, setErrorsName] = useState("")
  const [errorsMemberId, setErrorsMemberId] = useState("");
  const [errorsCardNumber, setErrorsCardNumber] = useState("")
  const [errorsEmail, setErrorsEmail] = useState("")
  
  
  const [countryCode, setCountryCode] = useState("")
  const [isMobileDuplicated,setIsMobileDuplicated] = useState(false);  
  //const [fieldValidCount, setFieldValidCount] = useState(0);
  const [mobilevalid, setMobileValid] = useState(false)
  const [policyChecked,setPolicyChecked] = useState(false);
  const [countValid,setCountValid] = useState(false);
  var logostr="https://omniqpon.co.in:14013/starcloudprnt/createpass/promoimage/";
  const [logoUrl,setLogoUrl]=useState("");//(logostr+"0");
  const[promotionList,setPromotionList] = useState([]);//useState([{id:1,name:"ppp"},{id:2,name:"vvv"},{id:3,name:"cccc"}]);
  
/*
  For omniqpon.co.au
  const REACT_APP_SITE_KEY='6LdAsx4dAAAAABLuJfONcGfzPAXZWpd-snvtlA5c'
  const REACT_APP_SECRET_KEY='6LdAsx4dAAAAALo1lh792x6XPY9ZhznameXA7V0YpqCM'
*/

 //For omniqpon.app
 //const REACT_APP_SITE_KEY='6LdOXZ8gAAAAAO0xb98eP3tKggtrWAD6uZr2sdmA'
 //const REACT_APP_SECRET_KEY='6LdOXZ8gAAAAAGu-WVybwxkyhMTfZ50gMpEbHS0C'

 //For omniqpon.net
 const REACT_APP_SITE_KEY='6Ldq_wsoAAAAAHxSyYh9BeWeNBQ6rja7sZSgfr1q'
 const REACT_APP_SECRET_KEY='6Ldq_wsoAAAAAArMfsDxh_tOkL5hB-EPKZ3VSZcG'

//for localhost
//For checkbox
// const REACT_APP_SITE_KEY='6LcnC9MiAAAAAF9JKccde65-xChP0bZkTHONZ4eB'
// const REACT_APP_SECRET_KEY='6LcnC9MiAAAAAN6Nfq_9nB6CsT_Fvp34yJbvE6Sy'

//For v2 invisible localhost
//const REACT_APP_SITE_KEY='6LfqdAInAAAAADL46raqJYEQq5vpDV87kw6193Di'
//const REACT_APP_SECRET_KEY='6LfqdAInAAAAAGD5j-Om7OSkPDwdRL6I4R_8ibT3'

//v2 invisible omniqpon.app
// const REACT_APP_SITE_KEY='6LdJwgInAAAAALZFxMC0WGwfK9YKXqxifRPX2bb4'
// const REACT_APP_SECRET_KEY='6LdJwgInAAAAALZFxMC0WGwfK9YKXqxifRPX2bb4'

//const reCaptchaRef = useRef(null);

  useEffect(() => {
    getPromotionList();
    
  
  }, [])

  useEffect(() => {
    if(promotionList !== null && promotionList.length >0 ){
      setFormValue({
        ...formValue,
        promotionId: promotionList[0].id
      });
    }
     
  }, [promotionList])
async  function  getPromotionList(){
  //   const captchaToken = await reCaptchaRef.current.executeAsync();
  // reCaptchaRef.current.reset();
  //setFormValue(formValue => ({...formValue,token:captchaToken}));

    DataService.getPromotion()
      .then(response => response.data)
      .then(results => setPromotionList(results))
      .catch(err => handlePromotionError(err));
}
function handlePromotionError(err){
  let errors={};
  errors["promo"] = "Error in receiving promotion list";
  setErrors(errors);
}
  // updating state here for name
const onChangeName = async (event) =>{
    //await setName(event.target.value)
    await setFormValue({
      ...formValue,
      memberName: event.target.value
    });
    
    validateName(event);

  }
  
  
  const onChangeCardNumber = async (event) =>{
    //await setName(event.target.value)
    await setFormValue({
      ...formValue,
      cardNumber: event.target.value
    });
    
    validateCardNumber(event);

  }

  const onChangeMemberId = async (event) =>{
    //await setName(event.target.value)
    await setFormValue({
      ...formValue,
      memberId: event.target.value
    });
    
    validateMemberId(event);

  }
  const onChangeEmail = async (event) =>{
    //await setName(event.target.value)
    await setFormValue({
      ...formValue,
      email: event.target.value
    });
    
    validateEmail(event.target.value);

  }
  const validateEmail = (email) => {
    let currentname = email;
    let currentnamevalid = true;
    // let errors = {}
    setErrorsEmail("");
    if (!currentname) {
      currentnamevalid = false;
      setErrorsEmail("Enter valid value");
      
    }
    
    if (typeof currentname !== undefined &&  currentname !== "") {
      if (!currentname.match(/\S+@\S+\.\S+/)) {
        setErrorsEmail("Enter valid value");
        
      }
    }
    
    
  }
  const onChangePromotion = async (event) =>{
    //await setName(event.target.value)
   console.log("ChangePromotion:"+event.target.value);
    await setFormValue({
      ...formValue,
      promotionId: event.target.value
    });
  }

  const handleToken = (token) => {
    console.log("token:"+token);
    //setToken(token);
    setFormValue({
    ...formValue,
    token: token
  });
  }

  //updating state here for mobile
  const onChangeMobile = async (phone,ctr) =>{
    
    //await setMobile(phone)
    await setFormValue({
      ...formValue,
      mobile: phone
    });
    await setCountryCode(ctr.dialCode);
    validateMobile(phone,ctr.dialCode)
  }

  const isFormValid = () => {
    let status = false
     let tempErr={};
    
    if (mobilevalid && errorsMemberId==="" && policyChecked &&
          errorsName==="" && errorsCardNumber==="" && errorsEmail==="" )
      status = true;
    
    return status

  }
  const onSubmit = async() => {
    validatePolicyCheckbox()
    validateMobile(formValue.mobile,countryCode);
    setFormValue(formValue => ({...formValue,timezone:Intl.DateTimeFormat().resolvedOptions().timeZone}));
  //  const token = await reRef.cu

  
    let errors = {};
    
    
    console.log(formValue);
    
    DataService.postActionOnSubmit(formValue)
    .then((response) => {
      
      console.log(response.data);
      if(response.data.error === 1)
      {
        errors["duplicate"] = response.data.message;//"Some error at backend server, please try again";
        setIsMobileDuplicated(true);
        setSubmitted(false);
        console.log("CheckPhoneDuplicate : DB Error");
      }
      else
      {
        if(response.data.IsPhoneNumberDuplicated === true)
        {
          errors["duplicate"] = response.data.message;//"Phone is already registered for this Promotion";
          setIsMobileDuplicated(true);
          setSubmitted(false);
          console.log("CheckPhoneDuplicate : Phone is already registered for this Promotion.");
        }
        else
        {
          errors["duplicate"] = "";
          setSubmitted(true);
          setIsMobileDuplicated(false);
          
          console.log("CheckPhoneDuplicate : Phone is not duplicated");
        }
        errors["pass"] = response.data.message;
      }
      setErrors(errors);
    })
    .catch((err) => {
      
      setSubmitted(false);
      errors["duplicate"] = "CONNECTION FAILED: Could not connect to backend server.";
      console.log("CheckPhoneDuplicate :"+err);
      setErrors(errors);
    })

    

  }
  const cancelAll = () => {
    
    window.location.reload(false)
  }

  

  const validateMemberId = (e) => {
    let currentName = e.target.name;
    let currentValue = e.target.value;
    let isValid = true;
    
    setErrorsMemberId("");
    if(!currentValue) {
    
      setErrorsMemberId("Enter valid  value");
    }
     else if(typeof currentValue !== typeof(undefined) ) {
      if(currentName==="memberName" & !currentValue.match(/^[a-z ,.'-]+$/i)) {
    
        setErrorsMemberId("Enter valid  value");
      }
      else if((currentName==="memberId" || currentName==="cardNumber" ) &
               !currentValue.match(/^[a-z0-9.-]+$/i)) {
    
        setErrorsMemberId("Enter valid  value");
      }
      else{
    
        setErrorsMemberId("");
      }
      
    }
  }
  const validateCardNumber = (e) => {
    let currentName = e.target.name;
    let currentValue = e.target.value;
    let isValid = true;
    setErrorsCardNumber("");
    
    if(!currentValue) {
      
      setErrorsCardNumber("Enter valid value");
    }
    else if(typeof currentValue !== typeof(undefined) ) {
      
      if((currentName==="memberId" || currentName==="cardNumber" ) &
               !currentValue.match(/^[a-z0-9.-]+$/i)) {
                setErrorsCardNumber("Enter valid value");
      }

      
    }
    else
        setErrorsCardNumber("");
    
    
  }



  const validateName = (e) => {
    let currentName = e.target.name;
    let currentValue = e.target.value;
    let currentnamevalid = true;
    
    setErrorsName("");
    if(!currentValue) {
      setErrorsName("Enter valid value");
    }
     if(typeof currentValue !== typeof(undefined) ) {
      if(currentName==="memberName" & !currentValue.match(/^[a-z ,.'-]+$/i)) {
        
        setErrorsName("Enter valid value");
      }
      else
        setErrorsName("");
      
    }
    
    
  }

  function handleMarketCheckbox(event)
  {
    
    setFormValue({...formValue,marketFlag:event.target.checked})
    //alert("market"+ event.target.checked);
  }
  function handlePolicyCheckbox(event)
  {
    setPolicyChecked(event.target.checked);
    
  }
  function validatePolicyCheckbox()
  {
    //alert("validatePolicyCheckbox");
    let errors = {}
    if(!policyChecked)
    {
      errors["policy"] = "Please check policy checkbox";
      setErrors(errors);
      return false;
    }
    else 
    {
      errors["policy"] = "";
      setErrors(errors);
      return true;
    }
    
  }
  const validateMobile = (onlymobile,ctrCode) => {
    
    //let onlymobile = mobile
    let mobilevalid = true
    let errors = {}
    
    if (!onlymobile) {
      mobilevalid = false;
      errors["mobile"] = "Cannot be empty";
    }
    if (typeof onlymobile !== "undefined") {
      console.log("In undef")
      //onlymobile = "+" + onlymobile
      ////(^d{1,4}[- ]?)?\d{10}$/)) {
      console.log(onlymobile);
      let regex ;
      if(ctrCode ==='91')
      {
        
        regex = RegExp(/^(\+?91|0)?[6789]\d{9}$/);
      }
      else if(ctrCode ==='1')
      {
        
        regex = RegExp(/^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/);
      }
      else if(ctrCode === '61')
      {
        
        regex = RegExp(/^(\+?61|0)4\d{8}$/);
      }
      //For AU if (!onlymobile.match())
      
     // if (!onlymobile.match())
      
      //if(!onlymobile.match(regex))
      if(!regex.test(onlymobile))
      {  
        //console.log("In valid")
        console.log("Check Valid");
        mobilevalid = false;
        errors["mobile"] = "Enter valid mobile number";
      }
      else
        errors["mobile"] = ""
    }
    console.log("Mobile valid" + mobilevalid)
    setErrors(errors)
    setMobileValid(mobilevalid)
    return mobilevalid;
  }





  return (
    <div className="container mt-5">
      
      {submitted ? (
        <div className="container">
          <h2 style={{ color: 'green', fontSize: '20px' }}>{errors["pass"] &&
                           <div><span style={{ color: "red" }}>{errors["pass"]}</span></div>}
          </h2>

          <button className="btn btn-success" onClick={cancelAll}>Go Back</button>
        </div>
      ) : (
        <div className="row ">

          <div className="col-md">
            <div className="container" style={{alignContent:'center',padding:'0 0 0 0'}}>
              {/* <div className="submit-form" style={{border:'5px solid grey'}}> */}
                <div className="row justify-content-md-center" style={{ }}>
          {/*border:'5px solid red'  */}
          {/* className="card" */}
                  <div  style={{ width: '100%',textAlign:"center",padding:'0 0 0 0'}} >
                  {/* border:'5px solid black', */}
                    <div className="card-body" style={{textAlign:'center',padding:'0 0 0 0'}}>
                        <div  style={{ textAlign:'center'}}>
                        {/* {logoUrl} */}
                        <img style={{width:'100%'}} src={logoUrl}></img>
                        </div>
                        
                        <div className="form-group" autoComplete="on"  style={{ }}>
                          <div style={{  margin:'0 auto',width:'80%'}}> 
                            <form onSubmit={onSubmit} autoComplete="on">
                              <div style={{textAlign:'left'}}>
                                 
                                <label htmlFor="memberId"  style={{ paddingBottom:10}} required>Member Id*</label>
                                  <input 
                                    placeholder="Enter your Member Id"
                                    type="text"
                                    className="form-control"
                                    id="memberId"
                                    required
                                    value={formValue.memberId}
                                    name="memberId"
                                    autoFocus={true}
                                    onBlur={event => {validateMemberId(event)}}
                                    onChange={event => { onChangeMemberId(event) }} //called a function instead of changing state here
                                  />
                                  <div><span style={{ color: "red" }}>{errorsMemberId}</span></div>



                                  <label htmlFor="memberName"  style={{ paddingBottom:10}} required>Name*</label>
                                  <input 
                                    placeholder="Enter your Name"
                                    type="text"
                                    className="form-control"
                                    id="memberName"
                                    required
                                    value={formValue.memberName}
                                    name="memberName"
                                    autoFocus={true}
                                    onBlur={event => {validateName(event)}}
                                    onChange={event => { onChangeName(event) }} //called a function instead of changing state here
                                  />
                                  <div><span style={{ color: "red" }}>{errorsName}</span></div>

                                  <label htmlFor="cardNumber"  style={{ paddingBottom:10}} required>Card Number*</label>
                                  <input 
                                    placeholder="Enter your card Number"
                                    type="text"
                                    className="form-control"
                                    id="cardNumber"
                                    required
                                    value={formValue.cardNumber}
                                    name="cardNumber"
                                    autoFocus={true}
                                    onBlur={event => {validateCardNumber(event)}}
                                    onChange={event => { onChangeCardNumber(event) }} //called a function instead of changing state here
                                  />
                                  <div><span style={{ color: "red" }}>{errorsCardNumber}</span></div>



                                  {/* value={mobile} */}
                                  <label htmlFor="phone"  
                                  style={{paddingTop:20,paddingBottom:10}}
                                  required>
                                    Mobile Number - Please do not enter preceding '0' *</label>
                                  {/* {" - Please do not enter preceding '0'"} */}

                                  <PhoneInput inputProps={{
                                    name: 'phone',
                                    required: true                            
                                  }} 
                                  value={formValue.mobile}
                                  countryCodeEditable={false}
                                  inputStyle={{width:'100%'}}
                                  copyNumbersOnly={false}
                                  country={'au'} 
                                  
                                  onlyCountries={['au','in']}
                                  onChange={ (phone,ctr) => onChangeMobile(phone,ctr)} // called a function instead of changing here
                                  //onBlur={phone => validateMobile(phone)}
                                  />
                                  

                                  {errors["mobile"] &&
                                  <div><span style={{ color: "red" }}>{errors["mobile"]}</span></div>}

                                  {errors["duplicate"] &&
                                  <div><span style={{ color: "red" }}>{errors["duplicate"]}</span></div>}

                                  <label htmlFor="email"  style={{ paddingBottom:10}} required>Email*</label>
                                  <input 
                                    placeholder="Enter your Email"
                                    type="text"
                                    className="form-control"
                                    id="email"
                                    required
                                    value={formValue.email}
                                    name="email"
                                    autoFocus={true}
                                    onBlur={event => {validateEmail(event.target.value)}}
                                    onChange={event => { onChangeEmail(event) }} //called a function instead of changing state here
                                  />
                                  <div><span style={{ color: "red" }}>{errorsEmail}</span></div>

                                  <label htmlFor="promotionId"  
                                    value={formValue.promotionId} 
                                    style={{ paddingBottom:10}} required>Select Promotion*</label>
                                  <select 
                                    placeholder="Enter promotion"
                                    type="number"
                                    className="form-control"
                                    id="couponCount"
                                    required
                                    value={formValue.promotionId}
                                    name="coupon Count"
                                    autoFocus={true}
                                    onChange={event => { onChangePromotion(event) }} //called a function instead of changing state here

                                  >
                                  {promotionList && promotionList.map((temp)=>(
                                  <option  value={temp.id} key={temp.id} >
                                    {temp.name}
                                  </option>))}
                                  </select>
                                  {errors["count"] &&
                                  <div><span style={{ color: "red" }}>{errors["count"]}</span></div>}
                                  <div style={{borderColor:'green',borderStyle:'none'}}>
                                  <ReCaptchaV2
                                  className="g-recaptcha"
                                    sitekey={REACT_APP_SITE_KEY}
                                    size="normal"
                                    
                                    onChange={handleToken}
                                    
                                    
                                     style={{ paddingTop:10}}
                                  />
                                  </div>
                                  {/* <div style={{borderColor:'green',borderStyle:'none'}}>
                                  <ReCAPTCHA
                                        // className="g-recaptcha"
                                        sitekey={REACT_APP_SITE_KEY}
                                        size="invisible"
                                        ref={reCaptchaRef}
                                      />
                                  </div>
                                   */}
                                  <div style={{backgroundColor: "lime",   color: "red" ,marginTop:"25px"}}>
                                  
                                  {errors["policy"] &&
                                  <div><span style={{ color: "red" }}>{errors["policy"]}</span></div>}

                                  </div>
                                  <div class="form-check" style={{marginTop:"10px"}} >
                                    <input class="form-check-input" 
                                      type="checkbox"
                                      id="checkboxAgreeMarket_notCompulsory" 
                                      name="checkboxAgreeMarket_notCompulsory"
                                      value={formValue.marketFlag}//"agreeCheckbox_notCompulsory"
                                      onChange={event => {handleMarketCheckbox(event)}}
                                      />
                                    <label class="form-check-label">
                                      Register me for OmniQpon promotions,events and exclusive offers</label>
                                  </div>
                                  <div class="form-check" style={{marginTop:"10px"}} >
                                    <input class="form-check-input" 
                                        type="checkbox" 
                                        id="checkboxAccept_Compulsory"
                                        name="checkboxAccept_Compulsory" 
                                        value={policyChecked}//"checkboxAccept_Compulsory" 
                                        onChange={event => {handlePolicyCheckbox(event)}}/>
                                    <label class="form-check-label">I agree to OmniQpon terms and conditions and privacy policy</label>
                                  </div>
                                </div>
                            </form>
                          </div>
                        </div>
                      
                          <div style={{ paddingTop: '15px' }} className="col-md-12 text-center">
                              <button style={{ marginRight: '16px' }} disabled={!isFormValid()} onClick={onSubmit}
                                className={`btn btn-success col s12 ${isFormValid() ? '' : 'disabled'}`}>
                                Submit
                              </button>
                              <button
                                style={{ marginRight: '16px' }}
                                onClick={cancelAll}
                                className={`btn btn-danger col s12 `}>
                                Cancel
                              </button>
                           </div>
                      </div>
                    
                  </div>
                </div>
              {/* </div> */}
           
            </div>


          </div>
        </div>)}
    </div>
  );
}

export default App;
